<form [formGroup]="form" (ngSubmit)="save()">
    <h1 mat-dialog-title>Retenciones</h1>
    <div mat-dialog-content>
        <mat-form-field class="medium-width margin-right-small">
            <mat-select formControlName="MedicalFeeWithholdTax" placeholder="Retención">
                <mat-option *ngFor="let medicalFeeWithholdTax of medicalFeeWithholdTaxs" [value]="medicalFeeWithholdTax">
                    {{ medicalFeeWithholdTax.Name }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="f.MedicalFeeWithholdTax.errors && f.MedicalFeeWithholdTax.errors.required">
                Seleccione una retención
            </mat-error>
        </mat-form-field>

        <mat-form-field class="medium-width">
            <mat-select formControlName="Aliquot" placeholder="Alícuota">
                <mat-option *ngFor="let aliquot of aliquots" [value]="aliquot">
                    {{ aliquot }}
                </mat-option>
            </mat-select>
            <mat-error *ngIf="f.Aliquot.errors && f.Aliquot.errors.required">
                Seleccione una alícuota
            </mat-error>
        </mat-form-field>

    </div>
    <div class="clearfix">
        <div class="pull-right">
            <button mat-button type="submit">Guardar</button>
            <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">Cancelar</button>
        </div>
    </div>
</form>